import React from 'react';

interface SearchResultsSummaryProps {
  count: number;
  query: string;
  location: string;
  isMobile: boolean;
}

const SearchResultsSummary: React.FC<SearchResultsSummaryProps> = ({ count, query, location, isMobile }) => {
  if (isMobile) {
    return (
      <div className="space-y-stack-sm md:hidden">
        <h2 className="font-headline-sm text-headline-sm-mobile text-on-surface">{count} Results for "{query}"</h2>
        <p className="font-body-md text-body-md text-on-surface-variant">Top-rated contractors in {location}</p>
      </div>
    );
  }

  return (
    <div className="hidden md:block">
      <h2 className="font-headline-md text-headline-md text-primary">Contractors in {location}</h2>
      <p className="font-body-md text-body-md text-on-surface-variant">{count} professionals found matching your filters</p>
    </div>
  );
};

export default SearchResultsSummary;
